document.addEventListener('DOMContentLoaded', () => {
  const button = document.querySelector('[data-auria-menu-button]');
  const nav = document.querySelector('[data-auria-nav]');
  if (button && nav) button.addEventListener('click', () => {
    const open = button.getAttribute('aria-expanded') === 'true';
    button.setAttribute('aria-expanded', String(!open));
    nav.classList.toggle('is-open', !open);
  });

  const catalog = document.querySelector('[data-auria-catalog]');
  if (!catalog) return;
  const selected = (new URLSearchParams(location.search).get('category') || 'all').toUpperCase();
  const cards = [...catalog.querySelectorAll('.auria-product-card')];
  let visible = 0;
  cards.forEach((card) => {
    const tags = (card.dataset.tags || '').toUpperCase().split('|');
    const leatherSelected = selected === 'LEATHER' || selected === 'AFTERLIFE SERIES LEATHER';
    const show = selected === 'ALL' || tags.includes(selected) ||
      (leatherSelected && tags.some(tag => tag === 'LEATHER' || tag === 'AFTERLIFE SERIES LEATHER'));
    card.hidden = !show;
    if (show) visible += 1;
  });
  catalog.querySelectorAll('[data-category-link]').forEach((link) => {
    link.classList.toggle('is-active', (link.dataset.categoryLink || '').toUpperCase() === selected);
  });
  const empty = catalog.querySelector('[data-filter-empty]');
  if (empty) empty.hidden = visible !== 0;
});
